import comp from "./IframeWrapper";
export default comp;
